// src/components/Contact.jsx
import { useState } from "react";
import { motion } from "framer-motion";
import emailjs from "@emailjs/browser";

export default function Contact() {
  const [isSent, setIsSent] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    title: "",
    message: "",
    time: new Date().toLocaleString(),
  });

    const SERVICE_ID = "service_qrawn8r";   // Replace with your EmailJS Service ID
    const TEMPLATE_ID = "template_qaclkyh";  // Replace with your EmailJS Template ID
    const PUBLIC_KEY = "lfgi06eIOhu5eFLMR";   // Replace with your EmailJS Public Key

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(SERVICE_ID, TEMPLATE_ID, formData, PUBLIC_KEY)
      .then(
        (result) => {
          console.log("EmailJS result:", result.text);
          setIsSent(true);
          setFormData({
            name: "",
            email: "",
            title: "",
            message: "",
            time: new Date().toLocaleString(),
          });
          setTimeout(() => setIsSent(false), 4000);
        },
        (error) => {
          console.error("EmailJS error:", error);
          setErrorMsg("❌ Something went wrong — please try again or contact us directly.");
        }
      );
  };

  return (
    <section className="relative bg-[#0f111a] py-20 px-6 md:px-16 text-white">
      <div className="max-w-4xl mx-auto text-center">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="text-4xl md:text-5xl font-extrabold mb-12 bg-clip-text text-transparent bg-gradient-to-r from-[#00fff7] to-[#0077ff]"
        >
          Get in Touch
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 1 }}
          className="text-gray-300 mb-12 text-lg"
        >
          Have an IT project or need professional IT support? Fill out the form below or reach us directly via email or phone.
        </motion.p>

        <motion.form
          onSubmit={handleSubmit}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4, duration: 1 }}
          className="grid grid-cols-1 gap-6"
        >
          <input
            name="name"
            type="text"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
            className="bg-[#1a1f2b] border border-gray-700 rounded-lg p-4 text-white focus:outline-none focus:ring-2 focus:ring-[#00fff7]"
          />
          <input
            name="email"
            type="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
            className="bg-[#1a1f2b] border border-gray-700 rounded-lg p-4 text-white focus:outline-none focus:ring-2 focus:ring-[#00fff7]"
          />
          <input
            name="title"
            type="text"
            placeholder="Subject"
            value={formData.title}
            onChange={handleChange}
            required
            className="bg-[#1a1f2b] border border-gray-700 rounded-lg p-4 text-white focus:outline-none focus:ring-2 focus:ring-[#00fff7]"
          />
          <textarea
            name="message"
            placeholder="Your Message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
            className="bg-[#1a1f2b] border border-gray-700 rounded-lg p-4 text-white focus:outline-none focus:ring-2 focus:ring-[#00fff7]"
          />
          {/* hidden time field */}
          <input type="hidden" name="time" value={formData.time} />

          <button
            type="submit"
            className="bg-gradient-to-r from-[#00fff7] to-[#0077ff] text-black font-semibold px-8 py-4 rounded-full shadow-lg hover:scale-105 transition-transform duration-300"
          >
            Send Message
          </button>
        </motion.form>

        {isSent && (
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="fixed bottom-10 right-10 bg-gradient-to-r from-[#00fff7] to-[#0077ff] text-black px-6 py-3 rounded-xl shadow-2xl font-semibold text-sm md:text-base z-50"
          >
            ✅ Message sent successfully! We’ll reach out as soon as possible.
          </motion.div>
        )}

        {errorMsg && (
          <motion.div className="text-red-500 font-semibold mt-4">{errorMsg}</motion.div>
        )}
      </div>
    </section>
  );
}
